'use strict';
var isNullOrUndefined = require('../internals/is-null-or-undefined');
var $TypeError = TypeError;

/**
 * 强制非null或undefined
 * @param {any} it
 * @returns {any}
 */
module.exports = function(it) {
  if (isNullOrUndefined(it)) {
    throw new $TypeError("Can't call method on " + it);
  }
  return it;
};
